import { Paper } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import LocationSearchInput from "./LocationSearchInput";

const LocationSearchFilter = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");

  const [query, setLocationQuery] = useQueryParams({
    lat: NumberParam,
    lon: NumberParam,
    location: StringParam,
    country: StringParam,
    page: NumberParam,
  });

  const setLocation = (location) => {
    if (!location) {
      setLocationQuery({
        lat: undefined,
        lon: undefined,
        location: undefined,
        country: undefined,
        page: 1,
      });
    }
    if (location?.type === "lat_lng") {
      setLocationQuery({
        lat: location.lat,
        lon: location.lon,
        location: location.location,
        country: undefined,
        page: 1,
      });
    }
    if (location?.type === "country_code") {
      setLocationQuery({
        lat: undefined,
        lon: undefined,
        location: location?.location,
        country: location?.value,
        page: 1,
      });
    }
  };

  return (
    <Paper
      shadow={!isMobile ? "sm" : null}
      p={isMobile ? 20 : "xs"}
      mt={isMobile ? 10 : 0}
      mb={15}
      style={{ zIndex: 999 }}
      withBorder
    >
      <LocationSearchInput
        defaultValue={query?.location ? query.location : ""}
        setLocation={setLocation}
      />
    </Paper>
  );
};

export default LocationSearchFilter;
